module.exports = __webpack_public_path__ + "img/brincos-cambria.0a5311a5.jpg";